import Swiper, {  Autoplay, Pagination, EffectFade } from 'swiper';

const Testimonials = () => {
  const swiper = new Swiper('.js-testimonials', {
    modules: [Autoplay, Pagination, EffectFade],
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 1000,
    slidesPerView: 1,

    pagination: {
      el: '.js-testimonials-pagination',
			clickable: true,
        renderBullet: function (index, className) {
          const objects = JSON.parse(this.el.dataset.pagination) || [];
          return '<div class="testimonial__circle ' + className + '"><div class="progress-thumb"><div class="progress-thumb__inner"><img src="'+ objects[index] +'" alt=""></div></div></div>';
        },
    }
  });
}

export default Testimonials;
